"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.CardContainer = void 0;
// styles
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
// utilities
const index_1 = require("../../Utilities/index");
const ripple = (color) => (0, Theme_1.css) `
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: ${(props) => `radial-gradient(circle, ${(color && Reflect.get(props.theme, color)) || props.theme.white} 10%, transparent 10.01%)`};
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform 0.5s, opacity 1s;
  }
  &:active::after {
    transform: scale(1, 1);
    opacity: 0.3;
    transition: 0s;
  }
`;
exports.CardContainer = Theme_1.styled.div `
  background-color: ${(props) => (props.color && Reflect.get(props.theme, props.color)) ||
    props.color ||
    props.theme.white};
  border-radius: 2px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  height: ${(props) => props.height || '56px'};
  justify-content: space-around;
  margin-bottom: 12px;
  width: ${(props) => props.width || '380px'};
  ${(props) => getBorderStyle(props.status)}
  ${(props) => props.onClick && ripple(props.color)}
  ${(props) => props.onClick &&
    `:hover {
      background-color: ${(0, index_1.lightenDarkenColor)(props.color ? props.color : props.theme.white, -0.15)};
    }`}
`;
const Card = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return react_1.default.createElement(exports.CardContainer, Object.assign({}, props), children);
};
exports.Card = Card;
function getBorderStyle(status) {
    if (status) {
        return (0, Theme_1.css) `
      border-left: 6px solid;
      border-left-color: ${(props) => Reflect.get(props.theme, status) || status || props.theme.blue};
    `;
    }
    return (0, Theme_1.css) `
    border: none;
  `;
}
//# sourceMappingURL=Card.js.map